export default "__VITE_ASSET__CRNTOrQd__"